var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVecinos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    fill: "none",
    viewBox: "0 0 21 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M10.49 12.93h-.082c-1.497-.026-2.708-.537-3.597-1.516-1.967-2.157-1.64-5.854-1.604-6.207C5.334 2.54 6.642 1.272 7.715.681 8.783.089 9.897 0 10.465 0h.086c1.032.02 1.957.258 2.749.7 1.063.592 2.35 1.859 2.478 4.507.036.353.363 4.05-1.604 6.207-.894.979-2.105 1.49-3.602 1.515H10.49zM6.574 5.307c-.002.007-.003.015-.003.024-.005.03-.353 3.423 1.267 5.192.639.706 1.502 1.054 2.626 1.064H10.515c1.13-.01 1.988-.358 2.632-1.064 1.624-1.779 1.267-5.158 1.262-5.192-.005-.01-.005-.025-.005-.04-.159-3.369-2.504-3.916-3.884-3.945h-.06c-1.115 0-3.715.382-3.884 3.945l-.002.016z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    d: "M20.99 19.06v-.014c0-.04-.005-.08-.005-.124-.031-.984-.097-3.285-2.315-4.02l-.051-.015c-2.304-.572-4.22-1.863-4.24-1.878-.313-.214-.742-.14-.961.164-.22.303-.143.72.168.934.087.06 2.12 1.436 4.665 2.072 1.19.412 1.323 1.65 1.36 2.783 0 .044 0 .084.004.124.005.447-.025 1.138-.107 1.535-.828.457-4.072 2.037-9.008 2.037-4.915 0-8.18-1.585-9.013-2.042-.082-.397-.118-1.088-.107-1.535 0-.04.005-.08.005-.125.035-1.132.168-2.37 1.359-2.782 2.544-.636 4.578-2.018 4.665-2.072.311-.214.388-.631.168-.934-.22-.303-.649-.378-.96-.164-.02.015-1.926 1.306-4.241 1.878l-.051.015c-2.218.74-2.284 3.04-2.315 4.02 0 .044 0 .084-.005.124v.015c-.005.258-.01 1.585.26 2.25.052.13.144.24.266.314.154.1 3.827 2.375 9.974 2.375s9.82-2.28 9.974-2.375c.117-.075.214-.184.265-.313.256-.661.25-1.988.246-2.246z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVecinos);
export default __webpack_public_path__ + "static/media/vecinos.1bdae0dbaa4a35b978375be4381185bd.svg";
export { ForwardRef as ReactComponent };